<template>
  <div class="w-screen min-h-screen flex flex-col overflow-auto">
    <NavbarPage />
    
    <router-view />
    <FooterPage />
    
  </div>
</template>

<script>
import NavbarPage from '@/components/NavbarPage.vue'
import FooterPage from './components/FooterPage.vue';


export default {
  name: 'App',
  components: {
    NavbarPage,
    FooterPage,
  }
}
</script>
